<template>

</template>

<script>
    export default {
        name: "ProductComparison"
    }
</script>

<style scoped>

</style>
